import { Cookie } from '@/src/general/utils/cookies/Cookie'

import type { TConnectDetails } from './connectDetails.types'

/**
 * Saves connect details as a cookie to handle redirection on connect.
 */
export const saveConnectDetails = (connectDetails: TConnectDetails): void =>
  Cookie.set('connectDetails', JSON.stringify(connectDetails), 'thirtyMinSecure')

/**
 * Get connect details previously stored in cookies.
 */
export const getConnectDetails = () =>
  // oxlint-disable-next-line @typescript-eslint/no-unsafe-type-assertion -- JSON.parse cookie boundary
  JSON.parse(Cookie.get('connectDetails') || '{}') as TConnectDetails

/**
 * Remove connect details cookie.
 */
export const removeConnectDetails = (): void => Cookie.delete('connectDetails', 'thirtyMinSecure')
